<template>
  <div class="isolate">
    <ComingSoonPage v-if="isComingSoonPage" />
    <template v-else-if="isModularPdpEnabled">
      <ProductJapanModular v-if="isJapanProductPage" />
      <GlobalProductDetailPage v-else />
    </template>
    <template v-else-if="!isModularPdpEnabled">
      <ProductJapan v-if="isJapanProductPage" />
      <Product v-else />
    </template>
  </div>
</template>

<script setup lang="ts">
import { useRoute, useRuntimeConfig } from '#imports'
import { computed, defineAsyncComponent } from 'vue'

import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { useMasterPP } from '~/scopes/product-core/composables/useMasterPP/useMasterPP'

const GlobalProductDetailPage = defineAsyncComponent(
  () =>
    import('~/scopes/product-core/pages/ProductDetailPage/global/GlobalProductDetailPage.vue'),
)
const ProductJapanModular = defineAsyncComponent(
  () =>
    import('~/scopes/product-core/pages/ProductDetailPage/jp/JPProductDetailPage.vue'),
)
const Product = defineAsyncComponent(
  () => import('~/scopes/product/pages/Product.vue'),
)
const ProductJapan = defineAsyncComponent(
  () => import('~/scopes/product/pages/Product-JP/Product-JP.vue'),
)
const ComingSoonPage = defineAsyncComponent(
  () => import('~/scopes/product-core/pages/ComingSoonPage/ComingSoonPage.vue'),
)

const route = useRoute()
const { market } = useMarketplace()
const { FF_MODULAR_PDP_ENABLED_BY_COUNTRY } = useRuntimeConfig().public
const { masterPDPComingSoon } = useMasterPP()

const isModularPdpEnabled = FF_MODULAR_PDP_ENABLED_BY_COUNTRY.includes(
  market.countryCode,
)

const isJapanProductPage = computed(
  () => market.countryCode === MarketCountryCode.JP,
)

const isComingSoonPage = computed(() => {
  return (
    route.params.slug === 'coming-soon-product-test' &&
    masterPDPComingSoon.value
  )
})
</script>
